// extracted by mini-css-extract-plugin
export default {"RegFormBox":"RegisterStyle_RegFormBox__9JL5H","RegContainer":"RegisterStyle_RegContainer__HgILh"};